import Vue from "vue"

export const activityAreaStore = {
  state: {
    activityArea: {},
    activityAreas: [],
    activityAreaPagination: {}
  },
  mutations: {
    SET_ACTIVITY_AREA_PROPERTY(state, { key, value }) {
      Vue.set(state.activityArea, key, value)
    },
    SET_ACTIVITY_AREA(state, activityArea) {
      Vue.set(state, 'activityArea', activityArea)
    },
    SET_ACTIVITY_AREAS(state, activityAreas) {
      Vue.set(state, 'activityAreas', activityAreas)
    },
    SET_ACTIVITY_AREA_PAGINATION(state, activityAreaPagination) {
      Vue.set(state, 'activityAreaPagination', activityAreaPagination)
    }
  },
  actions: {
    getActivityAreas({ commit }, params) {
      return new Promise((resolve, reject) => {
        Vue.http.get('api/v1/activity_areas', { params: params }).then(data => {
          if (data.ok) {
            commit('SET_ACTIVITY_AREAS', data.body.activity_areas)
            commit('SET_ACTIVITY_AREA_PAGINATION', data.body.pagination)
            resolve(data)
          }
        })
      })
    },
    createActivityArea({ commit }, params) {
      return new Promise((resolve, reject) => {
        Vue.http.post(`api/v1/activity_areas`, params)
          .then(data => {
            if (data.ok) {
              commit('SET_ACTIVITY_AREA', {})
              resolve(data)
            }
          })
          .catch(error => {
            if (error.body?.errors) {
              commit('error/SET_ERRORS', error.body.errors, { root: true })
              reject(error)
            }
          })
      })
    },
    updateActivityArea({ commit }, { params, activityAreaId }) {
      return new Promise((resolve, reject) => {
        Vue.http.patch(`api/v1/activity_areas/${activityAreaId}`, params)
          .then(data => {
            if (data.ok) {
              commit('SET_ACTIVITY_AREA', {})
              resolve(data)
            }
          })
          .catch(error => {
            if (error.body?.errors) {
              commit('error/SET_ERRORS', error.body.errors, { root: true })
              reject(error)
            }
          })
      })
    },
    deleteActivityArea({ commit }, activityAreaId) {
      return new Promise((resolve, reject) => {
        Vue.http.delete(`api/v1/activity_areas/${activityAreaId}`)
          .then(data => {
            if (data.ok) {
              resolve(data)
            }
          })
          .catch(error => {
            if (error.body?.errors) {
              commit('error/SET_ERRORS', error.body.errors, { root: true })
              reject(error)
            }
          })
      })
    }
  }
}